__turbopack_context__.v({
  "modal-trigger": "modal-trigger-module-scss-module__25V6SG__modal-trigger",
  "modal-trigger__actions": "modal-trigger-module-scss-module__25V6SG__modal-trigger__actions",
  "modal-trigger__actions--is-theme-secondary": "modal-trigger-module-scss-module__25V6SG__modal-trigger__actions--is-theme-secondary",
  "modal-trigger__button": "modal-trigger-module-scss-module__25V6SG__modal-trigger__button",
});
